import { render, staticRenderFns } from "./BuddhistNotes.vue?vue&type=template&id=76c33bd2&scoped=true"
import script from "./BuddhistNotes.vue?vue&type=script&lang=js"
export * from "./BuddhistNotes.vue?vue&type=script&lang=js"
import style0 from "./BuddhistNotes.vue?vue&type=style&index=0&id=76c33bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c33bd2",
  null
  
)

export default component.exports